export const isPollsterApp = process.env.NEXT_PUBLIC_APP_TARGET === 'pollster'
export const isAdminApp = process.env.NEXT_PUBLIC_APP_TARGET === 'admin'
